import LoggerService,{formatTrace} from '../../../services/LoggerService';
import INITIAL_STATE from './INITIAL_STATE';
import REDUCER_ACTIONS from './ACTIONS';

const LOG = LoggerService.getInstance();

const reducer = (
  state: any,
  action: any
) => {
	if (action.type === REDUCER_ACTIONS.SET_PAGE) {
		const {page} = action.payload;
    LOG.trace(...formatTrace('reducer - SET_PAGE',{page}));
		return {...state,page};
	}
	// return state;
	throw new Error(`No matching "${action.type}" action type`);
};

export {INITIAL_STATE};
export default reducer;
